import { ReactElement } from 'react';
import { Button, Flex } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

interface Props {
  handleClick: () => void;
  buttonText: string;
  children: ReactElement;
}

export function MobileBottomBar({ children, handleClick, buttonText }: Props) {
  const isMobileWidth = useMediaQuery('(max-width: 700px)');
  if (isMobileWidth) {
    return (
      <section className="mobile-bottom-bar">
        <div className="content">{children}</div>
        <Button onClick={handleClick} w="100%" color="nifoni" size="lg">
          <span>{buttonText}</span>
        </Button>
      </section>
    );
  }
  return (
    <section className="mobile-bottom-bar">
      <div className="wrapper">
        <div className="content">{children}</div>
        <Flex justify="center" align="center" mt={10}>
          <Button onClick={handleClick} w="100%" maw={500} color="nifoni" size="lg">
            <span>{buttonText}</span>
          </Button>
        </Flex>
      </div>
    </section>
  );
}
